import { render, staticRenderFns } from "./CreditNoteList.vue?vue&type=template&id=8b994b52&scoped=true&"
import script from "./CreditNoteList.vue?vue&type=script&lang=ts&"
export * from "./CreditNoteList.vue?vue&type=script&lang=ts&"
import style0 from "./CreditNoteList.vue?vue&type=style&index=0&id=8b994b52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b994b52",
  null
  
)

export default component.exports